// extracted by mini-css-extract-plugin
export default {"wrapper":"YxeYVw","visible":"w26Ksu","hidden":"JMxdWy","icon":"_y774K","text":"Vy3kR4"};